import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink, BrowserRouter, useHistory } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Header from '../Common/Header';
import { useDispatch } from 'react-redux';
import * as axios from "axios";
import Swal from 'sweetalert2';
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};


const ForgetPassword = () => {

  const [mobile, setMobile] = useState({ value: '', error: '', success: '' });

  const sendLink = async () => {

    if (mobile.value.length >= 10) {
      const res = await axios.post(`https://sms.rozgar.com/send-app-download-link`, { mobile: mobile.value })
      if (res.data.type === 'success') {
        setMobile({ ...mobile, success: `We have successfully sent App Download link to ${mobile.value}` })
      }

    }
    else {
      setMobile({ ...mobile, error: `Please enter a valid mobile number` })

    }
  }
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  //const [token, setToken] = useState(false);
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");


  const getUserName = () => {
    return {
      "username": username
    }
  }

  const ForgetPwd = (e) => {
    e.preventDefault();
    const jsonToPost = getUserName()
    generatelink(jsonToPost)
  }

  const generatelink = (jsonToPost) => {
    //alert(jsonToPost);
    //console.log(jsonToPost);
    //return false;
    sendlink(jsonToPost).then((res) => {
      if (res.status) {
        let result = Swal.fire({
          icon: "success",
          title: 'Link Generated',
          text: 'Please check Your Email Id!',
          footer: 'Forget Password Link Generated Successfully.'
        }).then(function (result) {
          window.location.href = "/"
        })
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: res.message
        })
      }
    })
  }


  const sendlink = (model) => {
    const url = `${CONFIG.BASE_URL}/user/forgetpwd`;
    return axios.post(url, model, getAuthHeader()).then((response) => {
      return response.data;
    });
  };


  return (
    <React.Fragment>
      <Header />
      <section className="loginbg">
        <div className="hero-section hero-section-login">
          <div className="container">
            <div className="hero-container">
              <div className="hero-left">
                <h1>Login to Get Your Dream Job</h1>

                <Form className="auth_form banner-form p-5 mt-3 shadow" onSubmit={ForgetPwd}>
                  <h4 className='pb-3'>Forget Password</h4>
                  <div class="form-group">
                    <Input
                      type="text"
                      className="form-control py-1"
                      placeholder="Enter Email"
                      name="email"
                      value={username} onChange={(e) => setUsername(e.target.value)}
                      validations={[required]}
                    />
                  </div>
                  <div class="form-group d-flex align-items-center justify-content-center mt-4 mb-2">
                    <button className="btn btn-primary-custom mx-2 w-100">
                      GENERATE LINK
                    </button>
                    {loading && (
                      <span className="spinner-border spinner-border-sm"></span>
                    )}
                  </div>
                  {message && (
                    <div className="form-group">
                      <div className="alert alert-danger" role="alert">
                        {message}
                      </div>
                    </div>
                  )}
                </Form>
              </div>
              <div className="hero-right d-none d-md-block">
                <img src="/assets/home/forgotepassword.png" alt="Login Image" className="pt-4 mt-4" />
              </div>
            </div>

          </div>

        </div>
      </section>

      <section>
        <div class="sw_our_newsletter_wrapper">
          <div class="container">
            <div class="row">
              <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                <div class="sw_nl_heading_wrapper sw_our_news_txt">
                  <i class="flaticon-rocket"></i>
                  <h2>Get Rozgar app link on your mobile</h2>
                  <h6>Get Rozgar app link on your mobile</h6>
                  <div class="prs_newsletter_field">
                    <input type="text" placeholder="Enter mobile number......" className={mobile.error.length > 0 && mobile.value.length < 10 && "error"} name={'mobile'} value={mobile.value} onChange={(e) => {
                      if (e.target.value.length <= 10 && !isNaN(e.target.value)) {
                        setMobile({ ...mobile, value: e.target.value })
                      }
                    }} />
                    <button type="submit" class="waves-effect waves-light waves-ripple" onClick={() => { sendLink() }}>Get link</button>
                  </div>
                  {mobile.success.length > 0 && <span className="text-success">{mobile.success}</span>}

                  {mobile.error.length > 0 && mobile.value.length < 10 && <span className="text-danger">{mobile.error}</span>}
                  <div className="mobileappbox">
                    <a target='_blank' href='https://play.google.com/store/apps/details?id=com.app.rozgar'>
                      <img src={'./assets/home/google-app.png'} /></a>
                    <a target='_blank' href='https://apps.apple.com/app/id6445827267'>
                      <img src={'./assets/home/iso-app.png'} /></a>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                <div class="sw_letter_img_wrapper wow  zoomIn  animated" data-wow-duration="1.3s" style={{ visibility: 'visible', animationDuration: '1.3s', animationName: 'zoomIn' }}>
                  <img src={'./assets/home/abt_ltr_img.png'} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="secttionLocation">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
            <ul className="citylocaiton">
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/mumbai"> Jobs in Mumbai City</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/delhi"> Jobs in Delhi</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gurugram"> Jobs in Gurugram</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/noida"> Jobs in Noida</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chennai"> Jobs in Chennai</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/pune"> Jobs in Pune</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/hyderabad"> Jobs in Hyderabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ahmedabad"> Jobs in Ahmedabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/lucknow"> Jobs in Lucknow</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chandigarh"> Jobs in Chandigarh</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jammu"> Jobs in Jammu</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/udaipur"> Jobs in Udaipur</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhubaneshwar"> Jobs in Bhubaneshwar</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhopal"> Jobs in Bhopal</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bareilly"> Jobs in Bareilly</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/cuttack"> Jobs in Cuttack</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jhansi"> Jobs in Jhansi</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gaya"> Jobs in Gaya</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/patna"> Jobs in Patna</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/moradabad"> Jobs in Moradabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nicobar"> Jobs in Nicobar</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/siliguri"> Jobs in Siliguri</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/tirunelveli"> Jobs in Tirunelveli</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/thane"> Jobs in Thane</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/vadodara"> Jobs in Vadodara</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nashik"> Jobs in Nashik</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/manglore"> Jobs in Manglore</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ujjain"> Jobs in Ujjain</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/coimbatore"> Jobs in Coimbatore</a></li>
                </ul>
            </div>
          </div>
        </div>
      </section>

      <footer class="footer-area">
        <div class="footer-top footer-top-style">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Jobs</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Search jobs</a></li>
                      <li><a href="#">Create Rozgar alert</a></li>
                      <li><a href="#">Register now</a></li>
                      <li><a href="#">Jobs by location</a></li>
                      <li><a href="#">Browse all jobs</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  {/* <div class="footer-title footer-title-style2">
                    <h3>&nbsp;</h3>
                  </div> */}
                  <h3>&nbsp;</h3>
                  <div class="item-link pt-3">
                    <ul>
                      <li><a href="#">Jobs by skill</a></li>
                      <li><a href="#">Jobs by designation</a></li>
                      <li><a href="#">Jobs by company</a></li>
                      <li><a href="#">Jobs by category</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2 min50">
                  <div class="footer-title footer-title-style2">
                    <h3>Freshers Jobs</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Latest fresher jobs</a></li>
                      <li><a href="#">Students</a></li>
                      <li><a href="#">Institution</a></li>
                      <li><a href="#">Hiring company</a></li>
                      <li><a href="#">Internships</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Companies</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Browse all companies</a></li>
                      <li><a href="#">Top companies</a></li>
                      <li><a href="#">Company reviews</a></li>
                      <li><a href="#">Interview questions</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Services</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Resume Creation</a></li>
                      <li><a href="#">Study abroad</a></li>
                      <li><a href="#">Admissions</a></li>
                      <li><a href="#">Students benefits</a></li>
                      <li><a href="#">Career Astrology</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-between mt-5">
              <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div class="footer-logo-area footer-logo-area-2">
                  <div class="item-logo">
                    <img src="/assets/home/rozgar.png" width="157" height="40" alt="logo" class="img-fluid" />
                  </div>
                  <div class="footer-contact footer-contact-style-2">
                    <div class="footer-location">
                      <ul>
                        <li class="item-map">
                          <i class="fas fa-map-marker-alt"></i> A-51 Sector 16 Noida, U.P. - 201301
                        </li>
                        <li>
                          <a href="mailto:contact@rozgar.com"><i class="fas fa-envelope"></i> contact@rozgar.com</a>
                        </li>
                        <li>
                          <a href="tel:+9177770 04946"><i class="fas fa-phone-alt"></i> +91 77770 04946</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h5 className="text-white">Connect with us</h5>
                  <div class="item-social">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/RozgarGlobal/" target="_blank"><i class="fab fa-facebook-f"></i></a>
                      </li>
                      <li>
                        <a href="https://twitter.com/rozgar_india" target="_blank"><i class="fab fa-twitter"></i></a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/rozgar" target="_blank"><i class="fab fa-linkedin"></i></a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/rozgarofficial/?hl=en" target="_blank"><i class="fab fa-instagram"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Quick Links</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Post a Job</a></li>
                      <li><a href="#">Companies</a></li>
                      <li><a href="#">Log In</a></li>
                      <li><a href="#">Register</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2 min50">
                  <div class="footer-title footer-title-style2">
                    <h3>Let's begin your search</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Explore cities</a></li>
                      <li><a href="#">Smart search</a></li>
                      <li><a href="#">Discussion forum</a></li>
                      <li><a href="#">Report an issue</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Resource centre</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">About Us</a></li>
                      <li><a href="#">Resume samples</a></li>
                      <li><a href="#">Blog</a></li>
                      <li><a href="#">FAQs</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Employer Zone</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a href="#">Buy online</a></li>
                      <li><a href="#">Our hiring solutions</a></li>
                      <li><a href="#">Employer login</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom footer-bottom-style-2">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12 col-md-12 text-center">
                <div class="copyright-area2">
                  <p>Copyright © 2021-22 Rozgar.com. All Rights Reserved | Powered by <a target='_blank' className="powercom" href="https://www.valueinnovationlabs.com/">Value Innovation Pvt. Ltd.</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  )

}


export default ForgetPassword